import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { MprcFormSubHeader } from "components";
import { Trans, useTranslation } from "react-i18next";
import { useBroadcastMessageContext } from "views/foundation/broadcastMessage/Home/StepManagement";

export const StepResult: React.FC = () => {

  const ctx = useBroadcastMessageContext();
  const { t } = useTranslation();

  return (
    <Stack alignContent="center" alignItems="center" mt={4}>
      <Card sx={{ minWidth: "650px" }}>
        <CardContent>
          <MprcFormSubHeader
            title={t("BroadcastMessage.StepResult.Title")}
            subtitle={t("BroadcastMessage.StepResult.HintText")}
          />
          {
            ctx.result && ctx.result.totalSuccess != null && ctx.result.totalSuccess > 0 &&
            <Box marginTop={3}>
              <Typography variant="h4" color="success.main">{t("BroadcastMessage.StepResult.SuccessSubtitle")}:</Typography>
              <Typography variant="body1" color="muted.main" marginLeft={4}>-&nbsp;
                <Trans
                  i18nKey="BroadcastMessage.StepResult.TotalSuccessMessage"
                  values={{ count: ctx.result.totalSuccess }}
                  t={t}
                />
              </Typography>
            </Box>
          }
          {
            ctx.result && ctx.result.totalFail != null && ctx.result.totalFail > 0 &&
            <Box marginTop={3}>
              <Typography variant="h4" color="error.main">{t("BroadcastMessage.StepResult.ErrorSubtitle")}:</Typography>
              <Stack direction="column">
                {ctx.result.usersFail?.map(item => (
                  <Typography variant="body1" color="muted.main" marginLeft={4}>-&nbsp;<strong>{item.name}: </strong>{item.message}
                  </Typography>
                ))
                }
              </Stack>
            </Box>
          }
        </CardContent>
      </Card>
    </Stack>
  );
};